export default __webpack_public_path__ + "static/media/litho-landing-page-portfolio-01.56e097ab.jpg";